import { SyncChildTimer, SyncTimer, Timer } from '../../types/timers'
import { formatISO } from 'date-fns'
import { captureException } from '@sentry/vue'
import { parseBool } from '../../utils'

export const mapTimersForSync = (timerRef: Timer[], user: any) => {
  return timerRef.map((parent) => {
    try {
      const { start_time, end_time, children, ...rest } = parent
      //join consecutive cart timers into one
      const newChildren: SyncChildTimer[] = []
      if (children.length) {
        for (let index = 0; index < children.length; index++) {
          const child = children[index]
          const lastNewChild = newChildren[newChildren.length - 1]
          if (
            lastNewChild &&
            lastNewChild.data &&
            lastNewChild.data?.order_type_id &&
            lastNewChild.data?.order_type_id == 2 &&
            child.data.order_type_id == lastNewChild.data?.order_type_id
          ) {
            //group into last one
            const res = lastNewChild
            const previousTaskData = lastNewChild.data.previous_task_data
              ? lastNewChild.data.previous_task_data
              : []
            res.data.previous_task_data = [...previousTaskData, child.data]
            //extend the new timer's end time
            //shouldn't happen but to make sure nothing breaks we will
            res.end_time = child.end_time ? formatISO(new Date(child.end_time)) : null
            newChildren[newChildren.length - 1] = res
          } else {
            const { start_time: c_start_time, end_time: c_end_time, ...c_rest } = child
            let newChild: SyncChildTimer = {
              ...c_rest,
              start_time: formatISO(new Date(c_start_time)),
              end_time: c_end_time ? formatISO(new Date(c_end_time)) : null,
            }
            newChild = updatePayCodesForChild(newChild, user)
            if (parseBool(child.data.revisit)) {
              newChild.data['project_code'] = PROJECT_CODES['revisit']
            }
            newChildren.push(newChild)
          }
        }
      }
      let newParent: SyncTimer = {
        ...rest,
        start_time: formatISO(new Date(start_time)),
        end_time: end_time ? formatISO(new Date(end_time)) : null,
        children: newChildren,
      }
      newParent = updateProjectCodesForParent(newParent)
      newParent = updatePayCodesForParent(newParent, user)

      return newParent
    } catch (e) {
      //capture any weirdness, cancel sync
      console.error({ error: e })
      console.error({ error: parent })
      captureException('Timer map failure')
    }
  })
}
export const updateProjectCodesForParent = (timer: SyncTimer) => {
  const newData = timer
  switch (newData.type) {
    case 'team':
    case 'other':
    case 'training':
    case 'material':
      newData.data['project_code'] = PROJECT_CODES[newData.type][newData.data.subtype]
      break
    case 'break':
      if (newData.data.subtype == 'paidBreak') {
        newData.data['project_code'] = PROJECT_CODES[newData.type]
      }
      break
    default:
      newData.data['project_code'] = PROJECT_CODES[newData.type]
      break
  }
  return newData
}

export const updatePayCodesForParent = (timer: SyncTimer, user: any) => {
  const newData = timer
  const country_id = String(user.country_id.value)
  //Canada at home gets a special code
  if (country_id == '2' && timer.data.location == 'home') {
    newData.data = { ...newData.data, ...PAYCODES['1C'][country_id] }
  } else {
    switch (timer.type) {
      case 'communication':
        newData.data = { ...newData.data, ...PAYCODES['1E'][country_id] }
        break
      case 'travel':
        newData.data = { ...newData.data, paycode_time: PAYCODES['1A'][country_id] }
        newData.data = { ...newData.data, paycode_mileage: PAYCODES['9A'][country_id] }
        break
      case 'break':
        if (newData.data.subtype == 'paidBreak') {
          newData.data = { ...newData.data, ...PAYCODES['1A'][country_id] }
        }
        break
      case 'other':
        if (newData.data.subtype == 'cartFraming') {
          newData.data = { ...newData.data, ...PAYCODES['1I'][country_id] }
          break
        }
        if (
          newData.data.subtype == 'operationSupport' ||
          newData.data.subtype == 'recruitingDuties'
        ) {
          newData.data = { ...newData.data, ...PAYCODES['1E'][country_id] }
          break
        }
      //similar to above, but am leaving separate as it will eventually get its own code
      case 'team':
        if (newData.data.subtype == 'cart') {
          newData.data = { ...newData.data, ...PAYCODES['1I'][country_id] }
          break
        }
      default:
        newData.data = { ...newData.data, ...PAYCODES['1A'][country_id] }
        break
    }
  }
  return newData
}

export const updatePayCodesForChild = (timer: SyncChildTimer, user: any) => {
  const newData = timer
  const country_id = String(user.country_id.value)
  if (parseBool(timer.data.revisit)) {
    //
    switch (timer.data.order_type_id) {
      case 1: //instore revisit
        newData.data = { ...newData.data, ...PAYCODES['1A'][country_id] }
        break
      case 2:
        if (country_id == '1') newData.data = { ...newData.data, ...PAYCODES['1A'][country_id] }
        else newData.data = { ...newData.data, ...PAYCODES['1I'][country_id] }
        break
      case 4:
        if (country_id == '1') newData.data = { ...newData.data, ...PAYCODES['1A'][country_id] }
        else newData.data = { ...newData.data, ...PAYCODES['1C'][country_id] }
        break
    }
  } else {
    switch (timer.data.order_type_id) {
      case 1: //instore
        newData.data = { ...newData.data, ...PAYCODES['1A'][country_id] }
        break
      case 2: //cart
        newData.data = { ...newData.data, ...PAYCODES['1I'][country_id] }
        break
      case 4: //merch
        if (country_id == '1') {
          newData.data = { ...newData.data, ...PAYCODES['1A'][country_id] }
        } else if (country_id == '2') {
          newData.data = { ...newData.data, ...PAYCODES['1B'][country_id] }
        }
        break
    }
  }
  return newData
}

const PROJECT_CODES: any = {
  break: '200001600105',
  communication: '200001600104',
  coupon: '200001600102',
  material: {
    core: '200001600103',
    merchandising: '201001600103',
    transfer: '200001600110',
  },
  store: '200001999999',
  training: {
    atStore: '200001600107',
    virtualOnline: '200001600096',
    virtualTrainer: '200001600087',
    retailMerchCoach: '200001600091',
  },
  other: {
    operationSupport: '200001600088',
    recruitingDuties: '200001600092',
    cartFraming: '200001600101',
    unscheduledTasks: '200001600108',
    minimumHourRequirement: '200001600109',
  },
  team: {
    instore: '200001999999',
    cart: '200001600101',
    merch: '201001600106',
  },
  revisit: '200001600093',
}

/**
 * To make lookup easy, each code is an obj w/ string representations
 * of country codes containing necessary keys
 */
const PAYCODES: any = {
  '1A': {
    '1': {
      pay_code_id: 1,
      pay_code: '1A',
      pay_code_type_id: 1,
      description: 'In-Store Execution 1A',
    },
    '2': {
      pay_code_id: 65,
      pay_code: '1A',
      pay_code_type_id: 1,
      description: 'In-Store Execution 1A',
    },
  },
  '1C': {
    '2': {
      pay_code_id: 69,
      pay_code: '1C',
      pay_code_type_id: 1,
      description: 'At Home Time 1C',
    },
  },
  '1E': {
    '1': {
      pay_code_id: 5,
      pay_code: '1E',
      pay_code_type_id: 1,
      description: 'Administrative 1E',
    },
    '2': {
      pay_code_id: 5,
      pay_code: '1E',
      pay_code_type_id: 1,
      description: 'Administrative 1E',
    },
  },
  '9A': {
    '1': {
      pay_code_id: 12,
      pay_code: '9A',
      pay_code_type_id: 2,
      description: 'Travel Expenses 9A (Mileage)',
    },
    '2': {
      pay_code_id: 67,
      pay_code: '9A',
      pay_code_type_id: 2,
      description: 'Travel Expenses 9A (Mileage)',
    },
  },
  '1I': {
    '1': {
      pay_code_id: 9,
      pay_code: '1I',
      pay_code_type_id: 1,
      description: 'Cart Execution 1I',
    },
    '2': {
      pay_code_id: 66,
      pay_code: '1I',
      pay_code_type_id: 1,
      description: 'Cart Execution 1I',
    },
  },
  '1B': {
    '2': {
      pay_code_id: 70,
      pay_code: '1B',
      pay_code_type_id: 1,
      description: 'Merchandising Time 1B',
    },
  },
}
